import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'

import Menu from '@material-ui/core/Menu'
import MenuItems from './menuItems'

const StyledMenu = (props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center'
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center'
    }}
    {...props}
  />
)
const Index = ({ onClickMenu, handleClose, onModal,onModalContact, stateAnchorEl }) => {
  return (
    <AppBar position="fixed" className="appBar-Main">
      <Toolbar>
        <Typography variant="h3" className="title">
          SuperPoolHipico
        </Typography>
        <IconButton onClick={onClickMenu} edge="start" className="menuButton" color="inherit" aria-label="menu">
          <MenuIcon />
        </IconButton>
        <StyledMenu
          id="customized-menu"
          anchorEl={stateAnchorEl}
          keepMounted
          open={Boolean(stateAnchorEl)}
          onClose={handleClose}
        >
          <div>
            <MenuItems onModal={onModal} onModalContact={onModalContact} />
          </div>
        </StyledMenu>
      </Toolbar>
    </AppBar>
  )
}

export default Index
